'use client';
import { ProjectCarouselType } from '../type';
import StandardGallery from '../../../gallery/standardGallery';
import { useState } from 'react';
import { Box, Paper, Stack } from '@mui/material';
import Tabs from './Tabs';
import Title from './Title';
import RichText from '../../../RichText';

type Props = {
  data: ProjectCarouselType;
};

const MobileServices = ({ data }: Props) => {
  const { flip, projects, styling } = data;
  const [selected, setSelected] = useState(0);
  const service = projects[selected];
  if (!service) return null;
  const shouldFlip = ['mobile', 'all'].includes(flip!);

  const images =
    service.images
      ?.map(({ after }) => {
        if (!after) return null;
        return {
          url: after.url!,
          alt: after.altText,
          thumbnailUrl: after.url!,
          blurUrl: after.blurDataUrl,
        };
      })
      .filter(Boolean) || [];
  return (
    <Stack
      direction={shouldFlip ? 'column-reverse' : 'column'}
      spacing={0}
      sx={{ borderRadius: 0.5, ...styling.sx }}
    >
      <Paper
        elevation={0}
        sx={{ my: 0.25, py: 3, px: 2, borderRadius: 'inherit' }}
        component={Stack}
        spacing={5}
      >
        <Tabs
          projects={projects}
          selected={selected}
          setSelected={setSelected}
        />
        <Title title={service.title} subTitle={service.subtitle} />
      </Paper>
      <Box
        sx={{
          aspectRatio: 1,
          width: '100%',
        }}
      >
        <StandardGallery
          images={images as []}
          isMobile
          sx={{ borderRadius: 0.5 }}
        />
      </Box>
      <Paper
        elevation={0}
        sx={{ my: 0.25, py: 3, px: 2, borderRadius: 'inherit' }}
        component={Stack}
        spacing={1.5}
      >
        <RichText>{service.description}</RichText>
      </Paper>
    </Stack>
  );
};

export default MobileServices;
